import React, { useState, useEffect, useCallback, useRef } from "react";
import "./style.css";

// ============================================================
// WORDFLOW NL - Complete NT2 Vocabulary Learning Platform
// Data from LinkMethode A2-B1 | Audio from original source
// ============================================================

const AUDIO_BASE = "https://a2b1.linkmethode.nl/StippWebDLL/Resources/Handlers/DownloadBestand.ashx?ID=";
const audioUrl = (id) => id ? AUDIO_BASE + id : null;

const WORDS = [
  // THEMA 1 - HUIS, BUURT EN WOONPLAATS
  {id:1,dutch:"aansluiting",article:"de",arabic:"توصيل",type:"noun",thema:1,themaName:"Huis & Wonen",unit:"Een nieuwe vloer",audioId:"1000017742",example_nl:"De aansluiting van de wasmachine is kapot.",example_ar:"توصيل الغسالة معطوب.",synonyms:["verbinding","koppeling"],difficulty:3},
  {id:2,dutch:"behangen",article:null,arabic:"يضع ورق الجدران",type:"verb",thema:1,themaName:"Huis & Wonen",unit:"Een nieuwe vloer",audioId:"1000017743",example_nl:"We gaan de woonkamer behangen.",example_ar:"سنضع ورق الجدران في غرفة المعيشة.",synonyms:["versieren","bekleden"],difficulty:4},
  {id:3,dutch:"binnenkant",article:"de",arabic:"الداخل",type:"noun",thema:1,themaName:"Huis & Wonen",unit:"Een nieuwe vloer",audioId:"1000017744",example_nl:"De binnenkant van het huis is mooi.",example_ar:"داخل المنزل جميل.",synonyms:["interieur"],difficulty:2},
  {id:4,dutch:"eigenaar",article:"de",arabic:"المالك",type:"noun",thema:1,themaName:"Huis & Wonen",unit:"Een nieuwe vloer",audioId:"1000017745",example_nl:"De eigenaar verhuurt het huis.",example_ar:"المالك يؤجر المنزل.",synonyms:["bezitter","eigenares"],difficulty:2},
  {id:5,dutch:"gordijn",article:"het",arabic:"الستارة",type:"noun",thema:1,themaName:"Huis & Wonen",unit:"Een nieuwe vloer",audioId:"1000017746",example_nl:"Het gordijn hangt voor het raam.",example_ar:"الستارة تتدلى أمام النافذة.",synonyms:["vitrage","rolgordijn"],difficulty:1},
  {id:6,dutch:"huren",article:null,arabic:"يستأجر",type:"verb",thema:1,themaName:"Huis & Wonen",unit:"Een nieuwe vloer",audioId:"1000017747",example_nl:"We huren een appartement.",example_ar:"نحن نستأجر شقة.",synonyms:["in huur nemen"],antonyms:["kopen","bezitten"],difficulty:1},
  {id:7,dutch:"huurhuis",article:"het",arabic:"بيت مستأجر",type:"noun",thema:1,themaName:"Huis & Wonen",unit:"Een nieuwe vloer",audioId:"1000017748",example_nl:"Ze wonen in een huurhuis.",example_ar:"يسكنون في بيت مستأجر.",synonyms:["huurwoning"],antonyms:["koophuis"],difficulty:2},
  {id:8,dutch:"inrichting",article:"de",arabic:"التأثيث",type:"noun",thema:1,themaName:"Huis & Wonen",unit:"Een nieuwe vloer",audioId:"1000017750",example_nl:"De inrichting van de kamer is modern.",example_ar:"تأثيث الغرفة عصري.",synonyms:["meubels","interieur"],difficulty:2},
  {id:9,dutch:"koophuis",article:"het",arabic:"بيت ملك",type:"noun",thema:1,themaName:"Huis & Wonen",unit:"Een nieuwe vloer",audioId:"1000019627",example_nl:"Ze hebben een koophuis.",example_ar:"لديهم بيت مملوك.",synonyms:["koopwoning"],antonyms:["huurhuis"],difficulty:2},
  {id:10,dutch:"leggen",article:null,arabic:"يضع / يفرش",type:"verb",thema:1,themaName:"Huis & Wonen",unit:"Een nieuwe vloer",audioId:"1000017751",example_nl:"We leggen een nieuwe vloer.",example_ar:"نضع أرضية جديدة.",synonyms:["plaatsen","neerleggen"],difficulty:1},
  {id:11,dutch:"muur",article:"de",arabic:"الحائط",type:"noun",thema:1,themaName:"Huis & Wonen",unit:"Een nieuwe vloer",audioId:"1000017754",example_nl:"De muur is wit geschilderd.",example_ar:"الحائط مدهون باللون الأبيض.",synonyms:["wand"],difficulty:1},
  {id:12,dutch:"opknappen",article:null,arabic:"يجدد / يرمم",type:"verb",thema:1,themaName:"Huis & Wonen",unit:"Een nieuwe vloer",audioId:"1000017756",example_nl:"Ze knapt het huis op.",example_ar:"تجدد المنزل.",synonyms:["renoveren","herstellen"],difficulty:3},
  {id:13,dutch:"vakman",article:"de",arabic:"الحرفي",type:"noun",thema:1,themaName:"Huis & Wonen",unit:"Een nieuwe vloer",audioId:"1000017760",example_nl:"De vakman repareert de kraan.",example_ar:"الحرفي يصلح الصنبور.",synonyms:["expert","specialist"],difficulty:2},
  {id:14,dutch:"verbouwen",article:null,arabic:"يجدد / يبني",type:"verb",thema:1,themaName:"Huis & Wonen",unit:"Een nieuwe vloer",audioId:"1000017761",example_nl:"Ze verbouwen de keuken.",example_ar:"يجددون المطبخ.",synonyms:["renoveren","ombouwen"],difficulty:3},
  {id:15,dutch:"verbouwing",article:"de",arabic:"التجديد / البناء",type:"noun",thema:1,themaName:"Huis & Wonen",unit:"Een nieuwe vloer",audioId:"1000017762",example_nl:"De verbouwing duurt drie weken.",example_ar:"التجديد يستغرق ثلاثة أسابيع.",synonyms:["renovatie"],difficulty:3},
  // THEMA 1 - Unit 2: Contact met de buurt
  {id:16,dutch:"aanraden",article:null,arabic:"ينصح",type:"verb",thema:1,themaName:"Huis & Wonen",unit:"Contact met de buurt",audioId:"1000017780",example_nl:"Ik raad dit restaurant aan.",example_ar:"أنصح بهذا المطعم.",synonyms:["adviseren","aanbevelen"],difficulty:2},
  {id:17,dutch:"alleenstaand",article:null,arabic:"أعزب / منفرد",type:"adjective",thema:1,themaName:"Huis & Wonen",unit:"Contact met de buurt",audioId:"1000017781",example_nl:"Ze is alleenstaand.",example_ar:"هي عزباء.",synonyms:["alleen","ongetrouwd"],antonyms:["getrouwd"],difficulty:3},
  {id:18,dutch:"cultuur",article:"de",arabic:"الثقافة",type:"noun",thema:1,themaName:"Huis & Wonen",unit:"Contact met de buurt",audioId:"1000017782",example_nl:"De Nederlandse cultuur is interessant.",example_ar:"الثقافة الهولندية مثيرة للاهتمام.",synonyms:["beschaving"],difficulty:2},
  {id:19,dutch:"eenzaam",article:null,arabic:"وحيد / منعزل",type:"adjective",thema:1,themaName:"Huis & Wonen",unit:"Contact met de buurt",audioId:"1000017784",example_nl:"Ze voelt zich eenzaam.",example_ar:"تشعر بالوحدة.",synonyms:["alleen"],antonyms:["sociaal","gezellig"],difficulty:2},
  {id:20,dutch:"inburgering",article:"de",arabic:"الاندماج المدني",type:"noun",thema:1,themaName:"Huis & Wonen",unit:"Contact met de buurt",audioId:"1000017787",example_nl:"Ze volgt een inburgeringscursus.",example_ar:"تتبع دورة الاندماج.",synonyms:["integratie"],difficulty:3,isNT2Key:true},
  {id:21,dutch:"pensioen",article:"het",arabic:"التقاعد",type:"noun",thema:1,themaName:"Huis & Wonen",unit:"Contact met de buurt",audioId:"1000017790",example_nl:"Hij gaat met pensioen.",example_ar:"يذهب إلى التقاعد.",synonyms:["AOW","ouderdomspensioen"],difficulty:2,isNT2Key:true},
  {id:22,dutch:"rijbewijs",article:"het",arabic:"رخصة القيادة",type:"noun",thema:1,themaName:"Huis & Wonen",unit:"Contact met de buurt",audioId:"1000017791",example_nl:"Ik haal mijn rijbewijs.",example_ar:"أحصل على رخصة القيادة.",synonyms:[],difficulty:2,isNT2Key:true},
  {id:23,dutch:"Staatsexamen",article:"het",arabic:"الامتحان الوطني NT2",type:"noun",thema:1,themaName:"Huis & Wonen",unit:"Contact met de buurt",audioId:"1000017793",example_nl:"Ze doet het Staatsexamen NT2.",example_ar:"تأدي امتحان NT2 الوطني.",synonyms:["NT2-examen"],difficulty:2,isNT2Key:true},
  {id:24,dutch:"taalmaatje",article:"het",arabic:"رفيق اللغة",type:"noun",thema:1,themaName:"Huis & Wonen",unit:"Contact met de buurt",audioId:"1000017795",example_nl:"Mijn taalmaatje spreekt goed Nederlands.",example_ar:"رفيق لغتي يتحدث هولندياً جيداً.",synonyms:["taalvriend"],difficulty:3,isNT2Key:true},
  {id:25,dutch:"vrijwilligerswerk",article:"het",arabic:"العمل التطوعي",type:"noun",thema:1,themaName:"Huis & Wonen",unit:"Contact met de buurt",audioId:"1000017798",example_nl:"Ze doet vrijwilligerswerk.",example_ar:"تعمل عملاً تطوعياً.",synonyms:["vrijwillige inzet"],difficulty:3,isNT2Key:true},
  // THEMA 1 - Unit 3: Kunt u een monteur sturen?
  {id:26,dutch:"centrale verwarming",article:"de",arabic:"التدفئة المركزية",type:"noun",thema:1,themaName:"Huis & Wonen",unit:"Kunt u een monteur sturen?",audioId:"1000017810",example_nl:"De centrale verwarming werkt niet.",example_ar:"التدفئة المركزية لا تعمل.",synonyms:["CV"],difficulty:2,isNT2Key:true},
  {id:27,dutch:"lekkage",article:"de",arabic:"التسرب",type:"noun",thema:1,themaName:"Huis & Wonen",unit:"Kunt u een monteur sturen?",audioId:"1000017815",example_nl:"Er is een lekkage in de badkamer.",example_ar:"يوجد تسرب في الحمام.",synonyms:[],difficulty:2},
  {id:28,dutch:"reparatie",article:"de",arabic:"الإصلاح",type:"noun",thema:1,themaName:"Huis & Wonen",unit:"Kunt u een monteur sturen?",audioId:"1000017820",example_nl:"De reparatie duurt twee uur.",example_ar:"الإصلاح يستغرق ساعتين.",synonyms:["herstel","fix"],difficulty:1,isNT2Key:true},
  {id:29,dutch:"woningbouwvereniging",article:"de",arabic:"جمعية الإسكان",type:"noun",thema:1,themaName:"Huis & Wonen",unit:"Kunt u een monteur sturen?",audioId:"1000017825",example_nl:"De woningbouwvereniging repareert het dak.",example_ar:"جمعية الإسكان تصلح السطح.",synonyms:["woningcorporatie","verhuurder"],difficulty:4,isNT2Key:true},
  // THEMA 1 - Unit 4: Mijn stad
  {id:30,dutch:"inwoner",article:"de",arabic:"السكان / المواطن",type:"noun",thema:1,themaName:"Huis & Wonen",unit:"Mijn stad",audioId:"1000017840",example_nl:"De stad heeft 100.000 inwoners.",example_ar:"المدينة بها 100.000 ساكن.",synonyms:["bewoner","burger"],difficulty:2,isNT2Key:true},
  // THEMA 2 - FAMILIE, VRIENDEN EN IK
  {id:31,dutch:"begrafenis",article:"de",arabic:"الجنازة",type:"noun",thema:2,themaName:"Familie & Relaties",unit:"Een verdrietig bericht",audioId:"1000017900",example_nl:"De begrafenis is morgen.",example_ar:"الجنازة غداً.",synonyms:["uitvaart"],difficulty:3},
  {id:32,dutch:"condoleren",article:null,arabic:"يعزي",type:"verb",thema:2,themaName:"Familie & Relaties",unit:"Een verdrietig bericht",audioId:"1000017902",example_nl:"Ik condoleer de familie.",example_ar:"أعزي العائلة.",synonyms:["meeleven"],difficulty:4},
  {id:33,dutch:"overlijden",article:null,arabic:"يتوفى",type:"verb",thema:2,themaName:"Familie & Relaties",unit:"Een verdrietig bericht",audioId:"1000017905",example_nl:"Hij is gisteren overleden.",example_ar:"توفي بالأمس.",synonyms:["sterven","overlijden"],difficulty:3,isNT2Key:true},
  {id:34,dutch:"traditie",article:"de",arabic:"التقليد / العادة",type:"noun",thema:2,themaName:"Familie & Relaties",unit:"Feest!",audioId:"1000017860",example_nl:"Dit is een oude traditie.",example_ar:"هذا تقليد قديم.",synonyms:["gewoonte","gebruik"],difficulty:2},
  {id:35,dutch:"verdrietig",article:null,arabic:"حزين",type:"adjective",thema:2,themaName:"Familie & Relaties",unit:"Een verdrietig bericht",audioId:"1000017907",example_nl:"Ze is verdrietig na het overlijden.",example_ar:"هي حزينة بعد الوفاة.",synonyms:["bedroefd","treurig"],antonyms:["blij","gelukkig"],difficulty:2},
  {id:36,dutch:"verslaafd",article:null,arabic:"مدمن",type:"adjective",thema:2,themaName:"Familie & Relaties",unit:"Altijd bereikbaar?",audioId:"1000017930",example_nl:"Hij is verslaafd aan zijn telefoon.",example_ar:"هو مدمن على هاتفه.",synonyms:["afhankelijk"],difficulty:3},
  {id:37,dutch:"optimistisch",article:null,arabic:"متفائل",type:"adjective",thema:2,themaName:"Familie & Relaties",unit:"De belangrijkste persoon",audioId:"1000017950",example_nl:"Ze is altijd optimistisch.",example_ar:"هي دائماً متفائلة.",synonyms:["positief"],antonyms:["pessimistisch","somber"],difficulty:2},
  // THEMA 3 - GEZONDHEID
  {id:38,dutch:"behandeling",article:"de",arabic:"العلاج",type:"noun",thema:3,themaName:"Gezondheid",unit:"Bij de huisarts",audioId:"1000018010",example_nl:"De behandeling duurt twee weken.",example_ar:"العلاج يستغرق أسبوعين.",synonyms:["therapie","zorg"],difficulty:2,isNT2Key:true},
  {id:39,dutch:"chronisch",article:null,arabic:"مزمن",type:"adjective",thema:3,themaName:"Gezondheid",unit:"Bij de huisarts",audioId:"1000018012",example_nl:"Ze heeft chronische pijn.",example_ar:"تعاني من ألم مزمن.",synonyms:["langdurig","aanhoudend"],difficulty:3,isNT2Key:true},
  {id:40,dutch:"diagnose",article:"de",arabic:"التشخيص",type:"noun",thema:3,themaName:"Gezondheid",unit:"Bij de huisarts",audioId:"1000018014",example_nl:"De diagnose was griep.",example_ar:"التشخيص كان الإنفلونزا.",synonyms:[],difficulty:3,isNT2Key:true},
  {id:41,dutch:"fysiotherapeut",article:"de",arabic:"المعالج الطبيعي",type:"noun",thema:3,themaName:"Gezondheid",unit:"Bij de huisarts",audioId:"1000018016",example_nl:"De fysiotherapeut helpt met rugpijn.",example_ar:"المعالج الطبيعي يساعد في آلام الظهر.",synonyms:["fysio"],difficulty:3,isNT2Key:true},
  {id:42,dutch:"patiënt",article:"de",arabic:"المريض",type:"noun",thema:3,themaName:"Gezondheid",unit:"Bij de huisarts",audioId:"1000018020",example_nl:"De patiënt wacht in de wachtkamer.",example_ar:"المريض ينتظر في غرفة الانتظار.",synonyms:["zieke"],difficulty:1,isNT2Key:true},
  {id:43,dutch:"verwijsbrief",article:"de",arabic:"خطاب الإحالة",type:"noun",thema:3,themaName:"Gezondheid",unit:"Bij de huisarts",audioId:"1000018025",example_nl:"De huisarts geeft een verwijsbrief.",example_ar:"طبيب العائلة يعطي خطاب إحالة.",synonyms:["doorverwijzing"],difficulty:3,isNT2Key:true},
  {id:44,dutch:"depressie",article:"de",arabic:"الاكتئاب",type:"noun",thema:3,themaName:"Gezondheid",unit:"Ik moet u onderzoeken",audioId:"1000018030",example_nl:"Ze heeft een depressie.",example_ar:"تعاني من اكتئاب.",synonyms:["neerslachtigheid"],difficulty:3,isNT2Key:true},
  {id:45,dutch:"operatie",article:"de",arabic:"العملية الجراحية",type:"noun",thema:3,themaName:"Gezondheid",unit:"Ik moet u onderzoeken",audioId:"1000018035",example_nl:"Ze heeft een operatie gehad.",example_ar:"خضعت لعملية جراحية.",synonyms:["ingreep"],difficulty:2,isNT2Key:true},
  {id:46,dutch:"gezondheidszorg",article:"de",arabic:"الرعاية الصحية",type:"noun",thema:3,themaName:"Gezondheid",unit:"Ik moet u onderzoeken",audioId:"1000018037",example_nl:"De gezondheidszorg in Nederland is goed.",example_ar:"الرعاية الصحية في هولندا جيدة.",synonyms:["zorg","medische zorg"],difficulty:3,isNT2Key:true},
  {id:47,dutch:"ontspannen",article:null,arabic:"يسترخي",type:"verb",thema:3,themaName:"Gezondheid",unit:"Ik heb last van stress",audioId:"1000018050",example_nl:"Probeer meer te ontspannen.",example_ar:"حاول الاسترخاء أكثر.",synonyms:["relaxen","rusten"],antonyms:["spannen","stressen"],difficulty:2,isNT2Key:true},
  {id:48,dutch:"spanning",article:"de",arabic:"الضغط / التوتر",type:"noun",thema:3,themaName:"Gezondheid",unit:"Ik heb last van stress",audioId:"1000018052",example_nl:"Er is veel spanning op het werk.",example_ar:"يوجد ضغط كبير في العمل.",synonyms:["stress","druk"],antonyms:["rust","ontspanning"],difficulty:2,isNT2Key:true},
  // THEMA 4 - GELD
  {id:49,dutch:"basisverzekering",article:"de",arabic:"التأمين الأساسي",type:"noun",thema:4,themaName:"Geld & Verzekering",unit:"Goed verzekerd",audioId:"1000018150",example_nl:"Iedereen heeft een basisverzekering nodig.",example_ar:"كل شخص يحتاج إلى التأمين الأساسي.",synonyms:[],difficulty:3,isNT2Key:true},
  {id:50,dutch:"premie",article:"de",arabic:"قسط التأمين",type:"noun",thema:4,themaName:"Geld & Verzekering",unit:"Goed verzekerd",audioId:"1000018155",example_nl:"De premie is hoog.",example_ar:"قسط التأمين مرتفع.",synonyms:[],difficulty:3,isNT2Key:true},
  {id:51,dutch:"verzekeren",article:null,arabic:"يؤمّن",type:"verb",thema:4,themaName:"Geld & Verzekering",unit:"Goed verzekerd",audioId:"1000018158",example_nl:"Je moet je huis verzekeren.",example_ar:"يجب أن تؤمّن منزلك.",synonyms:["beschermen"],difficulty:2,isNT2Key:true},
  {id:52,dutch:"zorgverzekeraar",article:"de",arabic:"شركة التأمين الصحي",type:"noun",thema:4,themaName:"Geld & Verzekering",unit:"Goed verzekerd",audioId:"1000018162",example_nl:"Welke zorgverzekeraar heb jij?",example_ar:"من هي شركة التأمين الصحي لديك؟",synonyms:["verzekeraar"],difficulty:3,isNT2Key:true},
  {id:53,dutch:"spaargeld",article:"het",arabic:"المدخرات",type:"noun",thema:4,themaName:"Geld & Verzekering",unit:"Kopen of sparen?",audioId:"1000018100",example_nl:"Ik heb spaargeld voor een huis.",example_ar:"لديّ مدخرات لشراء منزل.",synonyms:["spaarrekening","savings"],difficulty:2},
  // THEMA 5 - ONDERWIJS
  {id:54,dutch:"onderwijs",article:"het",arabic:"التعليم",type:"noun",thema:5,themaName:"Onderwijs",unit:"Naar school in Nederland",audioId:"1000018250",example_nl:"Het onderwijs in Nederland is goed.",example_ar:"التعليم في هولندا جيد.",synonyms:["opleiding","educatie"],difficulty:1,isNT2Key:true},
  {id:55,dutch:"diploma",article:"het",arabic:"الشهادة",type:"noun",thema:5,themaName:"Onderwijs",unit:"Een mbo-opleiding",audioId:"1000018260",example_nl:"Ze heeft haar diploma gehaald.",example_ar:"حصلت على شهادتها.",synonyms:["certificaat"],difficulty:1,isNT2Key:true},
  {id:56,dutch:"opleiding",article:"de",arabic:"الدورة / التدريب",type:"noun",thema:5,themaName:"Onderwijs",unit:"Naar school in Nederland",audioId:"1000018255",example_nl:"Welke opleiding doe je?",example_ar:"ما هي الدورة التي تدرسها؟",synonyms:["studie","cursus"],difficulty:1,isNT2Key:true},
  {id:57,dutch:"taalcursus",article:"de",arabic:"دورة اللغة",type:"noun",thema:5,themaName:"Onderwijs",unit:"Hoe leer je Nederlands?",audioId:"1000018310",example_nl:"Ze volgt een taalcursus.",example_ar:"تتبع دورة لغة.",synonyms:["taallessen"],difficulty:2,isNT2Key:true},
  {id:58,dutch:"woordenschat",article:"de",arabic:"المفردات",type:"noun",thema:5,themaName:"Onderwijs",unit:"Hoe leer je Nederlands?",audioId:"1000018315",example_nl:"Mijn woordenschat wordt beter.",example_ar:"مفرداتي تتحسن.",synonyms:["vocabulaire"],difficulty:3,isNT2Key:true},
  {id:59,dutch:"rijles",article:"de",arabic:"درس السياقة",type:"noun",thema:5,themaName:"Onderwijs",unit:"Ik zag die voetganger niet",audioId:"1000018280",example_nl:"Ik neem rijlessen.",example_ar:"آخذ دروس سياقة.",synonyms:[],difficulty:2},
  // THEMA 6 - WERK & TOEKOMST
  {id:60,dutch:"sollicitatie",article:"de",arabic:"طلب العمل",type:"noun",thema:6,themaName:"Werk & Sollicitatie",unit:"Een baan zoeken",audioId:"1000018400",example_nl:"Ze heeft een sollicitatie morgen.",example_ar:"لديها مقابلة عمل غداً.",synonyms:["aanvraag","jobapplicatie"],difficulty:2,isNT2Key:true},
  {id:61,dutch:"cv",article:"het",arabic:"السيرة الذاتية",type:"noun",thema:6,themaName:"Werk & Sollicitatie",unit:"Een baan zoeken",audioId:"1000018405",example_nl:"Stuur je cv op.",example_ar:"أرسل سيرتك الذاتية.",synonyms:["curriculum vitae"],difficulty:1,isNT2Key:true},
  {id:62,dutch:"arbeidsmarkt",article:"de",arabic:"سوق العمل",type:"noun",thema:6,themaName:"Werk & Sollicitatie",unit:"Een baan zoeken",audioId:"1000018408",example_nl:"De arbeidsmarkt is veranderd.",example_ar:"سوق العمل تغيّر.",synonyms:["werkmarkt","jobmarkt"],difficulty:3,isNT2Key:true},
  {id:63,dutch:"werkervaring",article:"de",arabic:"خبرة عمل",type:"noun",thema:6,themaName:"Werk & Sollicitatie",unit:"Vrijwilligers gezocht",audioId:"1000018380",example_nl:"Heb je werkervaring?",example_ar:"هل لديك خبرة عملية؟",synonyms:["ervaring","beroepservaring"],difficulty:2,isNT2Key:true},
  {id:64,dutch:"leidinggevende",article:"de",arabic:"المسؤول / الرئيس",type:"noun",thema:6,themaName:"Werk & Sollicitatie",unit:"Sollicitatiegesprek",audioId:"1000018430",example_nl:"Mijn leidinggevende is aardig.",example_ar:"مسؤولي لطيف.",synonyms:["baas","manager","chef"],difficulty:2,isNT2Key:true},
  {id:65,dutch:"vrijwilligerswerk",article:"het",arabic:"عمل تطوعي",type:"noun",thema:6,themaName:"Werk & Sollicitatie",unit:"Vrijwilligers gezocht",audioId:"1000018378",example_nl:"Ze doet vrijwilligerswerk.",example_ar:"تعمل عملاً تطوعياً.",synonyms:["vrijwillige inzet"],difficulty:3,isNT2Key:true},
  // THEMA 7 - COMMUNICATIE
  {id:66,dutch:"inkomen",article:"het",arabic:"الدخل",type:"noun",thema:7,themaName:"Overheid & Communicatie",unit:"Zorgtoeslag",audioId:"1000018530",example_nl:"Mijn inkomen is laag.",example_ar:"دخلي منخفض.",synonyms:["verdiensten","salaris"],difficulty:2,isNT2Key:true},
  {id:67,dutch:"zorgtoeslag",article:"de",arabic:"بدل التأمين الصحي",type:"noun",thema:7,themaName:"Overheid & Communicatie",unit:"Zorgtoeslag",audioId:"1000018535",example_nl:"Vraag je zorgtoeslag aan.",example_ar:"اطلب بدل التأمين الصحي.",synonyms:["toeslag","subsidie"],difficulty:3,isNT2Key:true},
  {id:68,dutch:"rekeningnummer",article:"het",arabic:"رقم الحساب",type:"noun",thema:7,themaName:"Overheid & Communicatie",unit:"Zorgtoeslag",audioId:"1000018540",example_nl:"Wat is uw rekeningnummer?",example_ar:"ما هو رقم حسابك؟",synonyms:["IBAN","banknummer"],difficulty:2,isNT2Key:true},
  {id:69,dutch:"burgerservicenummer",article:"het",arabic:"رقم هوية المواطن",type:"noun",thema:7,themaName:"Overheid & Communicatie",unit:"Zorgtoeslag",audioId:"1000018542",example_nl:"Mijn BSN is 123456789.",example_ar:"رقم BSN الخاص بي.",synonyms:["BSN","sofinummer"],difficulty:2,isNT2Key:true},
  {id:70,dutch:"wijzigen",article:null,arabic:"يعدّل",type:"verb",thema:7,themaName:"Overheid & Communicatie",unit:"Zorgtoeslag",audioId:"1000018548",example_nl:"U kunt uw adres wijzigen.",example_ar:"يمكنك تعديل عنوانك.",synonyms:["veranderen","aanpassen"],difficulty:2,isNT2Key:true},
  // THEMA 8 - NEDERLAND
  {id:71,dutch:"melding",article:"de",arabic:"البلاغ",type:"noun",thema:8,themaName:"Nederland & Veiligheid",unit:"Melding politie",audioId:"1000018620",example_nl:"Je moet een melding doen bij de politie.",example_ar:"يجب أن تقدم بلاغاً للشرطة.",synonyms:["aangifte","klacht"],difficulty:2,isNT2Key:true},
  {id:72,dutch:"politie",article:"de",arabic:"الشرطة",type:"noun",thema:8,themaName:"Nederland & Veiligheid",unit:"Melding politie",audioId:"1000018622",example_nl:"Bel de politie!",example_ar:"اتصل بالشرطة!",synonyms:["agent","orde"],difficulty:1,isNT2Key:true},
  {id:73,dutch:"misdaad",article:"de",arabic:"الجريمة",type:"noun",thema:8,themaName:"Nederland & Veiligheid",unit:"Melding politie",audioId:"1000018625",example_nl:"Misdaad moet gemeld worden.",example_ar:"يجب الإبلاغ عن الجرائم.",synonyms:["misdrijf","strafbaar feit"],difficulty:2},
  {id:74,dutch:"koningshuis",article:"het",arabic:"العائلة المالكة",type:"noun",thema:8,themaName:"Nederland & Veiligheid",unit:"Fan van koningin Maxima",audioId:"1000018680",example_nl:"Het koningshuis woont in Den Haag.",example_ar:"العائلة المالكة تسكن في لاهاي.",synonyms:["monarchie","koninklijke familie"],difficulty:3},
  {id:75,dutch:"brandalarm",article:"het",arabic:"إنذار الحريق",type:"noun",thema:8,themaName:"Nederland & Veiligheid",unit:"Noodsituatie",audioId:"1000018660",example_nl:"Het brandalarm gaat af.",example_ar:"ينطلق إنذار الحريق.",synonyms:["rookmelder","branddetector"],difficulty:3,isNT2Key:true},
  // THEMA 9 - VRIJE TIJD
  {id:76,dutch:"eetcultuur",article:"de",arabic:"ثقافة الطعام",type:"noun",thema:9,themaName:"Vrije Tijd",unit:"Aan tafel",audioId:"1000018750",example_nl:"De eetcultuur verschilt per land.",example_ar:"ثقافة الطعام تختلف من بلد إلى آخر.",synonyms:["keuken","voedselcultuur"],difficulty:3},
  {id:77,dutch:"vervoermiddel",article:"het",arabic:"وسيلة النقل",type:"noun",thema:9,themaName:"Vrije Tijd",unit:"Onderweg",audioId:"1000018800",example_nl:"De fiets is een populair vervoermiddel.",example_ar:"الدراجة وسيلة نقل شائعة.",synonyms:["transport"],difficulty:2,isNT2Key:true},
  {id:78,dutch:"arbeidscontract",article:"het",arabic:"عقد العمل",type:"noun",thema:9,themaName:"Vrije Tijd",unit:"Op vakantie",audioId:"1000018850",example_nl:"Hij heeft een arbeidscontract.",example_ar:"لديه عقد عمل.",synonyms:["contract","arbeidsovereenkomst"],difficulty:2,isNT2Key:true},
  // THEMA 10 - VEILIGHEID
  {id:79,dutch:"bescherming",article:"de",arabic:"الحماية",type:"noun",thema:10,themaName:"Veiligheid",unit:"Veilige werkomgeving",audioId:"1000018920",example_nl:"De bescherming van werknemers is belangrijk.",example_ar:"حماية العمال مهمة.",synonyms:["beveiliging","veiligheid"],difficulty:2,isNT2Key:true},
  {id:80,dutch:"letsel",article:"het",arabic:"الإصابة",type:"noun",thema:10,themaName:"Veiligheid",unit:"Veilige werkomgeving",audioId:"1000018925",example_nl:"Hij heeft letsel opgelopen.",example_ar:"أصيب بجرح.",synonyms:["blessure","wond","schade"],difficulty:3,isNT2Key:true},
  // THEMA 11 - WERK COMMUNICATIE
  {id:81,dutch:"bedrijfscultuur",article:"de",arabic:"ثقافة الشركة",type:"noun",thema:11,themaName:"Werk & Communicatie",unit:"Werken in Nederland",audioId:"1000019000",example_nl:"De bedrijfscultuur is informeel.",example_ar:"ثقافة الشركة غير رسمية.",synonyms:["werksfeer","organisatiecultuur"],difficulty:3,isNT2Key:true},
  {id:82,dutch:"overwerken",article:null,arabic:"يعمل ساعات إضافية",type:"verb",thema:11,themaName:"Werk & Communicatie",unit:"Overwerken",audioId:"1000019050",example_nl:"Ik moet alweer overwerken.",example_ar:"عليّ العمل ساعات إضافية مرة أخرى.",synonyms:["extra werken","meer uren werken"],difficulty:3},
  {id:83,dutch:"functioneringsgesprek",article:"het",arabic:"مقابلة تقييم الأداء",type:"noun",thema:11,themaName:"Werk & Communicatie",unit:"Gesprek leidinggevende",audioId:"1000019080",example_nl:"Morgen heb ik een functioneringsgesprek.",example_ar:"غداً لديّ مقابلة تقييم الأداء.",synonyms:["beoordelingsgesprek"],difficulty:4,isNT2Key:true},
  // THEMA 12 - GEZONDHEID WERK
  {id:84,dutch:"bedrijfsarts",article:"de",arabic:"طبيب الشركة",type:"noun",thema:12,themaName:"Gezondheid & BHV",unit:"Bedrijfsarts",audioId:"1000019150",example_nl:"De bedrijfsarts is er elke dinsdag.",example_ar:"طبيب الشركة موجود كل ثلاثاء.",synonyms:["arbo-arts"],difficulty:3,isNT2Key:true},
  {id:85,dutch:"levensstijl",article:"de",arabic:"نمط الحياة",type:"noun",thema:12,themaName:"Gezondheid & BHV",unit:"Gezonde levensstijl",audioId:"1000019160",example_nl:"Een gezonde levensstijl is belangrijk.",example_ar:"نمط الحياة الصحي مهم.",synonyms:["manier van leven","levenswijze"],difficulty:2,isNT2Key:true},
  // THEMA 13 - CONTACT MAKEN
  {id:86,dutch:"inburgeren",article:null,arabic:"يندمج في المجتمع",type:"verb",thema:13,themaName:"Integratie & Contact",unit:"Thuis in Nederland",audioId:"1000019250",example_nl:"Ze is goed ingeburgerd.",example_ar:"لقد اندمجت جيداً.",synonyms:["integreren"],difficulty:3,isNT2Key:true},
  {id:87,dutch:"vluchteling",article:"de",arabic:"اللاجئ",type:"noun",thema:13,themaName:"Integratie & Contact",unit:"Thuis in Nederland",audioId:"1000019255",example_nl:"Ze is vluchteling uit Syrië.",example_ar:"هي لاجئة من سوريا.",synonyms:["asielzoeker","ontheemde"],difficulty:2,isNT2Key:true},
  {id:88,dutch:"zelfredzaamheid",article:"de",arabic:"الاعتماد على النفس",type:"noun",thema:13,themaName:"Integratie & Contact",unit:"Thuis in Nederland",audioId:"1000019260",example_nl:"Zelfredzaamheid is belangrijk voor inburgering.",example_ar:"الاعتماد على النفس مهم للاندماج.",synonyms:["zelfstandigheid","onafhankelijkheid"],difficulty:4,isNT2Key:true},
  {id:89,dutch:"verliefd",article:null,arabic:"واقع في الغرام",type:"adjective",thema:13,themaName:"Integratie & Contact",unit:"Eerste ontmoeting",audioId:"1000019300",example_nl:"Hij is verliefd op haar.",example_ar:"هو واقع في غرامها.",synonyms:["smoorverliefd"],antonyms:["onverschillig"],difficulty:2},
  {id:90,dutch:"verloving",article:"de",arabic:"الخطوبة",type:"noun",thema:13,themaName:"Integratie & Contact",unit:"Eerste ontmoeting",audioId:"1000019305",example_nl:"Ze vieren hun verloving.",example_ar:"يحتفلون بخطوبتهم.",synonyms:["engagement"],difficulty:3},
  // THEMA 14 - STAGE
  {id:91,dutch:"stage",article:"de",arabic:"التدريب العملي",type:"noun",thema:14,themaName:"Stage & Werk",unit:"Stage lopen",audioId:"1000019400",example_nl:"Ze loopt stage bij een ziekenhuis.",example_ar:"تتدرب في مستشفى.",synonyms:["stageplek","praktijkervaring"],difficulty:1,isNT2Key:true},
  {id:92,dutch:"stageverslag",article:"het",arabic:"تقرير التدريب",type:"noun",thema:14,themaName:"Stage & Werk",unit:"Wat heb je geleerd?",audioId:"1000019420",example_nl:"Ze schrijft haar stageverslag.",example_ar:"تكتب تقرير التدريب.",synonyms:["verslag","rapport"],difficulty:3},
  {id:93,dutch:"burgemeester",article:"de",arabic:"عمدة المدينة",type:"noun",thema:14,themaName:"Stage & Werk",unit:"Welkom op stage",audioId:"1000019450",example_nl:"De burgemeester heet iedereen welkom.",example_ar:"يرحب عمدة المدينة بالجميع.",synonyms:["stadsbestuurder"],difficulty:2,isNT2Key:true},
  {id:94,dutch:"gemeentehuis",article:"het",arabic:"مبنى البلدية",type:"noun",thema:14,themaName:"Stage & Werk",unit:"Welkom op stage",audioId:"1000019455",example_nl:"Het gemeentehuis is in het centrum.",example_ar:"مبنى البلدية في وسط المدينة.",synonyms:["stadhuis","gemeente"],difficulty:2,isNT2Key:true},
  // THEMA 15 - AAN HET WERK
  {id:95,dutch:"sollicitatiebrief",article:"de",arabic:"خطاب طلب الوظيفة",type:"noun",thema:15,themaName:"Werk & Sollicitatie",unit:"Schriftelijk solliciteren",audioId:"1000019550",example_nl:"Schrijf een goede sollicitatiebrief.",example_ar:"اكتب خطاب طلب وظيفة جيد.",synonyms:["motivatiebrief"],difficulty:2,isNT2Key:true},
  {id:96,dutch:"arbeidsvoorwaarden",article:"de",arabic:"شروط الوظيفة",type:"noun",thema:15,themaName:"Werk & Sollicitatie",unit:"Waarom wil je werken?",audioId:"1000019560",example_nl:"Wat zijn de arbeidsvoorwaarden?",example_ar:"ما هي شروط الوظيفة؟",synonyms:["arbeidscontract","CAO"],difficulty:3,isNT2Key:true},
  {id:97,dutch:"bedrijfsplan",article:"het",arabic:"خطة الشركة",type:"noun",thema:15,themaName:"Werk & Sollicitatie",unit:"Eigen baas",audioId:"1000019600",example_nl:"Hij heeft een goed bedrijfsplan.",example_ar:"لديه خطة شركة جيدة.",synonyms:["businessplan","ondernemingsplan"],difficulty:3},
  {id:98,dutch:"vergunning",article:"de",arabic:"التصريح / الرخصة",type:"noun",thema:15,themaName:"Werk & Sollicitatie",unit:"Eigen baas",audioId:"1000019605",example_nl:"Je hebt een vergunning nodig.",example_ar:"تحتاج إلى تصريح.",synonyms:["licentie","ontheffing"],difficulty:3,isNT2Key:true},
  {id:99,dutch:"gemeente",article:"de",arabic:"البلدية",type:"noun",thema:15,themaName:"Werk & Sollicitatie",unit:"Eigen baas",audioId:"1000019610",example_nl:"De gemeente geeft de vergunning.",example_ar:"البلدية تمنح التصريح.",synonyms:["stad","plaatselijk bestuur"],difficulty:1,isNT2Key:true},
  {id:100,dutch:"belastingdienst",article:"de",arabic:"مصلحة الضرائب",type:"noun",thema:7,themaName:"Overheid & Communicatie",unit:"Belastingen",audioId:"1000019620",example_nl:"De Belastingdienst stuurt een brief.",example_ar:"مصلحة الضرائب ترسل خطاباً.",synonyms:["fiscus","belasting"],difficulty:2,isNT2Key:true}
];

// SM-2 Spaced Repetition Algorithm
const sm2 = (card, rating) => {
  let {ef=2.5, interval=1, reps=0} = card;
  if(rating >= 3) {
    if(reps===0) interval=1;
    else if(reps===1) interval=6;
    else interval=Math.round(interval*ef);
    reps++;
  } else { reps=0; interval=1; }
  ef = Math.max(1.3, ef + 0.1 - (5-rating)*(0.08+(5-rating)*0.02));
  interval = Math.min(365, interval);
  const next = new Date(); next.setDate(next.getDate()+interval);
  const mastery = reps===0?0:reps===1?1:reps<=3&&ef<2?2:reps<=5&&ef<2.5?3:reps<=8?4:5;
  return {ef,interval,reps,next,mastery};
};

const speak = (text) => {
  const u = new SpeechSynthesisUtterance(text);
  u.lang="nl-NL"; u.rate=0.85; u.pitch=1;
  window.speechSynthesis.cancel();
  window.speechSynthesis.speak(u);
};

const playAudio = (audioId) => {
  if(audioId) {
    try {
      const a = new Audio(getAudio(audioId));
      a.play().catch(()=>speak(audioId));
    } catch(e) { speak(audioId); }
  }
};

const shuffle = arr => [...arr].sort(()=>Math.random()-0.5);
const getMasteryColor = (l) => ['#6b7280','#ef4444','#f97316','#eab308','#22c55e','#3b82f6'][l]||'#6b7280';
const getMasteryLabel = (l) => ['جديدة','أتعلمها','مراجعة','مألوفة','محفوظة','خبير'][l]||'جديدة';
const getXP = (r) => [0,5,10,15,20,25][r]||0;

// ======= MAIN APP =======
export default function App() {
  const [page, setPage] = useState("dashboard");
  const [progress, setProgress] = useState(() => {
    const saved = localStorage.getItem("wf_progress");
    return saved ? JSON.parse(saved) : {};
  });
  const [stats, setStats] = useState(() => {
    const saved = localStorage.getItem("wf_stats");
    return saved ? JSON.parse(saved) : {xp:0,level:1,streak:0,lastDay:"",totalReviews:0,correct:0,wrong:0};
  });
  const [dark, setDark] = useState(true);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => { localStorage.setItem("wf_progress", JSON.stringify(progress)); }, [progress]);
  useEffect(() => { localStorage.setItem("wf_stats", JSON.stringify(stats)); }, [stats]);

  const addXP = useCallback((xp) => {
    setStats(s => {
      const newXP = s.xp + xp;
      const newLevel = Math.floor(newXP/200)+1;
      return {...s, xp:newXP, level:newLevel};
    });
  }, []);

  const updateProgress = useCallback((wordId, rating) => {
    setProgress(prev => {
      const card = prev[wordId] || {ef:2.5,interval:1,reps:0};
      const result = sm2(card, rating);
      return {...prev, [wordId]: result};
    });
    addXP(getXP(rating));
    setStats(s => ({...s,
      totalReviews: s.totalReviews+1,
      correct: rating>=3 ? s.correct+1 : s.correct,
      wrong: rating<3 ? s.wrong+1 : s.wrong
    }));
  }, [addXP]);

  const dueWords = WORDS.filter(w => {
    const p = progress[w.id];
    if(!p) return true;
    return new Date(p.next) <= new Date();
  });

  const learnedCount = Object.keys(progress).length;
  const masteredCount = Object.values(progress).filter(p => p.mastery>=4).length;
  const accuracy = stats.totalReviews>0 ? Math.round((stats.correct/stats.totalReviews)*100) : 0;

  const navItems = [
    {id:"dashboard",icon:"🏠",label:"Dashboard"},
    {id:"flashcards",icon:"📚",label:"Flashcards"},
    {id:"review",icon:"🔁",label:"Herhaling"},
    {id:"quiz",icon:"❓",label:"Quiz"},
    {id:"match",icon:"🎮",label:"Match Game"},
    {id:"fill",icon:"✏️",label:"Fill in Blank"},
    {id:"speed",icon:"⚡",label:"Speed Challenge"},
    {id:"wordlist",icon:"📝",label:"Woordenlijst"},
    {id:"ai",icon:"🤖",label:"AI Tutor"},
    {id:"stats",icon:"📊",label:"Statistieken"},
    {id:"exam",icon:"🎓",label:"Examen Mode"},
  ];

  return (
    <div className="app" style={{background:dark?"#0f172a":"#f8fafc",color:dark?"#f1f5f9":"#1e293b"}}>
      
      {/* Mobile Header */}
      <div style={{display:"none"}} className="mobile-header">
        <button onClick={()=>setMenuOpen(!menuOpen)} style={{background:"none",border:"none",color:"#60a5fa",fontSize:"24px",cursor:"pointer"}}>
          ☰
        </button>
        <span style={{fontWeight:800,color:"#60a5fa"}}>WordFlow NL</span>
        <button onClick={()=>setDark(!dark)} style={{background:"none",border:"none",color:"#94a3b8",fontSize:"20px",cursor:"pointer"}}>{dark?"☀️":"🌙"}</button>
      </div>

      {/* Sidebar */}
      <div className="sidebar" style={{background:dark?"#1e293b":"#fff",borderColor:dark?"#334155":"#e2e8f0"}}>
        <div className="logo">🇳🇱 WordFlow NL</div>
        
        {/* Level & XP */}
        <div style={{background:dark?"#0f172a":"#f1f5f9",borderRadius:"12px",padding:"12px",marginBottom:"8px"}}>
          <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",marginBottom:"6px"}}>
            <span className="level-badge">Level {stats.level}</span>
            <span style={{color:"#f59e0b",fontSize:"12px",fontWeight:700}}>🔥 {stats.streak}</span>
          </div>
          <div className="progress-bar">
            <div className="progress-fill xp-bar" style={{width:Math.min(100,(stats.xp%(stats.level*200))/(stats.level*200)*100)+"%"}}></div>
          </div>
          <div style={{color:"#64748b",fontSize:"11px",marginTop:"4px"}}>{stats.xp} XP</div>
        </div>

        {navItems.map(n => (
          <div key={n.id} className={"nav-item "+(page===n.id?"active":"")} onClick={()=>{setPage(n.id);setMenuOpen(false);}}>
            <span>{n.icon}</span>
            <span>{n.label}</span>
            {n.id==="review" && dueWords.length>0 && <span style={{background:"#ef4444",color:"#fff",borderRadius:"20px",padding:"2px 8px",fontSize:"11px",marginLeft:"auto"}}>{dueWords.length}</span>}
          </div>
        ))}

        <div style={{marginTop:"auto"}}>
          <div className="nav-item" onClick={()=>setDark(!dark)}>
            <span>{dark?"☀️":"🌙"}</span>
            <span>{dark?"Light Mode":"Dark Mode"}</span>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="main">
        {page==="dashboard" && <Dashboard stats={stats} dueWords={dueWords} learnedCount={learnedCount} masteredCount={masteredCount} accuracy={accuracy} progress={progress} setPage={setPage} dark={dark}/>}
        {page==="flashcards" && <FlashCards words={WORDS} progress={progress} updateProgress={updateProgress} dark={dark}/>}
        {page==="review" && <ReviewMode words={dueWords.length>0?dueWords:WORDS} progress={progress} updateProgress={updateProgress} dark={dark}/>}
        {page==="quiz" && <QuizMode words={WORDS} updateProgress={updateProgress} addXP={addXP} dark={dark}/>}
        {page==="match" && <MatchGame words={WORDS} addXP={addXP} dark={dark}/>}
        {page==="fill" && <FillBlank words={WORDS} updateProgress={updateProgress} addXP={addXP} dark={dark}/>}
        {page==="speed" && <SpeedChallenge words={WORDS} addXP={addXP} dark={dark}/>}
        {page==="wordlist" && <WordList words={WORDS} progress={progress} setPage={setPage} dark={dark}/>}
        {page==="ai" && <AITutor words={WORDS} dark={dark}/>}
        {page==="stats" && <Statistics stats={stats} progress={progress} words={WORDS} accuracy={accuracy} dark={dark}/>}
        {page==="exam" && <ExamMode words={WORDS} progress={progress} updateProgress={updateProgress} addXP={addXP} dark={dark}/>}
      </div>
    </div>
  );
}

// ======= DASHBOARD =======
function Dashboard({stats,dueWords,learnedCount,masteredCount,accuracy,progress,setPage,dark}) {
  const themaGroups = {};
  WORDS.forEach(w=>{ if(!themaGroups[w.themaName]) themaGroups[w.themaName]=0; themaGroups[w.themaName]++; });
  return (
    <div>
      <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",marginBottom:"24px"}}>
        <div>
          <h1 className="page-title" style={{marginBottom:"4px"}}>مرحباً بك! 👋</h1>
          <p style={{color:"#64748b"}}>استمر في التعلم اليوم</p>
        </div>
        <span className="level-badge" style={{fontSize:"16px"}}>Level {stats.level} 🏆</span>
      </div>

      {/* Stats Grid */}
      <div className="stats-grid">
        {[
          {val:WORDS.length,label:"إجمالي الكلمات",icon:"📚",color:"#3b82f6"},
          {val:learnedCount,label:"تمت مراجعتها",icon:"✅",color:"#22c55e"},
          {val:masteredCount,label:"محفوظة",icon:"⭐",color:"#f59e0b"},
          {val:dueWords.length,label:"تحتاج مراجعة",icon:"🔁",color:"#ef4444"},
          {val:accuracy+"%",label:"دقة الإجابات",icon:"🎯",color:"#8b5cf6"},
          {val:stats.streak+"🔥",label:"أيام متتالية",icon:"",color:"#f97316"},
        ].map((s,i)=>(
          <div key={i} className="stat-card" style={{borderLeft:"4px solid "+s.color}}>
            <div className="stat-val" style={{color:s.color}}>{s.icon} {s.val}</div>
            <div className="stat-label">{s.label}</div>
          </div>
        ))}
      </div>

      {/* Quick Actions */}
      <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(180px,1fr))",gap:"16px",marginBottom:"24px"}}>
        {[
          {page:"review",label:dueWords.length>0?`مراجعة (${dueWords.length})`:"مراجعة",icon:"🔁",color:"#3b82f6"},
          {page:"flashcards",label:"بطاقات تعليمية",icon:"📚",color:"#8b5cf6"},
          {page:"quiz",label:"اختبار سريع",icon:"❓",color:"#22c55e"},
          {page:"match",label:"لعبة المطابقة",icon:"🎮",color:"#f59e0b"},
          {page:"speed",label:"تحدي السرعة",icon:"⚡",color:"#ef4444"},
          {page:"ai",label:"مدرس ذكي",icon:"🤖",color:"#06b6d4"},
        ].map((a,i)=>(
          <button key={i} onClick={()=>setPage(a.page)} className="btn btn-primary" style={{background:a.color,padding:"20px",borderRadius:"16px",fontSize:"16px",display:"flex",flexDirection:"column",alignItems:"center",gap:"8px",border:"none"}}>
            <span style={{fontSize:"28px"}}>{a.icon}</span>
            <span>{a.label}</span>
          </button>
        ))}
      </div>

      {/* Topics */}
      <div className="card" style={{background:dark?"#1e293b":"#fff"}}>
        <h3 style={{marginBottom:"16px",color:"#60a5fa"}}>📖 المواضيع</h3>
        <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(200px,1fr))",gap:"10px"}}>
          {Object.entries(themaGroups).map(([name,count],i)=>(
            <div key={i} style={{background:dark?"#0f172a":"#f8fafc",borderRadius:"12px",padding:"12px",border:"1px solid "+(dark?"#334155":"#e2e8f0")}}>
              <div style={{fontWeight:700,color:"#f1f5f9",fontSize:"13px",marginBottom:"4px"}}>{name}</div>
              <div style={{color:"#64748b",fontSize:"12px"}}>{count} كلمة</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

// ======= FLASHCARDS =======
function FlashCards({words,progress,updateProgress,dark}) {
  const [idx, setIdx] = useState(0);
  const [flipped, setFlipped] = useState(false);
  const [thema, setThema] = useState(0);
  const filtered = thema===0 ? words : words.filter(w=>w.thema===thema);
  const word = filtered[idx];
  const p = word ? (progress[word.id]||{mastery:0}) : {mastery:0};

  const next = (rating) => {
    if(word) updateProgress(word.id, rating);
    setFlipped(false);
    setTimeout(()=>setIdx(i=>(i+1)%filtered.length),200);
  };

  if(!word) return <div>لا توجد كلمات</div>;

  const themas = [...new Set(words.map(w=>w.thema))];

  return (
    <div>
      <h1 className="page-title">📚 بطاقات تعليمية</h1>
      
      {/* Thema Filter */}
      <div className="thema-filter">
        <button className={"thema-btn "+(thema===0?"active":"")} onClick={()=>{setThema(0);setIdx(0);setFlipped(false);}}>الكل</button>
        {themas.map(t=>(
          <button key={t} className={"thema-btn "+(thema===t?"active":"")} onClick={()=>{setThema(t);setIdx(0);setFlipped(false);}}>
            Thema {t}
          </button>
        ))}
      </div>

      {/* Progress */}
      <div style={{display:"flex",alignItems:"center",gap:"12px",marginBottom:"20px"}}>
        <span style={{color:"#64748b"}}>{idx+1} / {filtered.length}</span>
        <div className="progress-bar" style={{flex:1}}>
          <div className="progress-fill" style={{width:((idx+1)/filtered.length*100)+"%"}}></div>
        </div>
        <span style={{padding:"4px 12px",borderRadius:"20px",fontSize:"12px",fontWeight:700,background:getMasteryColor(p.mastery)+"33",color:getMasteryColor(p.mastery)}}>
          {getMasteryLabel(p.mastery)}
        </span>
      </div>

      {/* Card */}
      <div className="flashcard-container">
        <div className="flashcard" onClick={()=>setFlipped(!flipped)}>
          <div className={"card-inner "+(flipped?"flipped":"")}>
            <div className="card-front">
              {word.article && <div className="article-badge">{word.article}</div>}
              <div className="word-nl">{word.dutch}</div>
              <div style={{color:"rgba(255,255,255,0.7)",fontSize:"13px",marginTop:"8px"}}>{word.type==="noun"?"اسم":word.type==="verb"?"فعل":word.type==="adjective"?"صفة":"كلمة"}</div>
              <button className="audio-btn" onClick={e=>{e.stopPropagation();speak(word.dutch);}}>
                🔊
              </button>
              <div style={{color:"rgba(255,255,255,0.4)",fontSize:"12px",marginTop:"8px"}}>انقر للمعنى ↻</div>
            </div>
            <div className="card-back">
              <div className="word-ar">{word.arabic}</div>
              {word.example_nl && (
                <div className="example-box" style={{marginTop:"16px"}}>
                  <div className="example-nl">"{word.example_nl}"</div>
                  <div className="example-ar">{word.example_ar}</div>
                </div>
              )}
              {word.synonyms && word.synonyms.length>0 && (
                <div className="synonyms">
                  {word.synonyms.slice(0,3).map(s=>(
                    <span key={s} className="syn-badge">{s}</span>
                  ))}
                </div>
              )}
              <button className="audio-btn" style={{marginTop:"12px"}} onClick={e=>{e.stopPropagation();speak(word.dutch);}}>🔊</button>
            </div>
          </div>
        </div>

        {flipped && (
          <div className="rating-btns">
            <button className="rating-btn btn-again" onClick={()=>next(1)}>😞 لا أعرف</button>
            <button className="rating-btn btn-hard" onClick={()=>next(2)}>😐 صعبة</button>
            <button className="rating-btn btn-good" onClick={()=>next(4)}>🙂 أعرفها</button>
            <button className="rating-btn btn-easy" onClick={()=>next(5)}>🎉 سهلة!</button>
          </div>
        )}

        <div style={{display:"flex",gap:"12px"}}>
          <button className="btn btn-primary" onClick={()=>{setIdx(i=>(i-1+filtered.length)%filtered.length);setFlipped(false);}}>⬅️ السابق</button>
          <button className="btn" style={{background:"#334155",color:"#94a3b8"}} onClick={()=>{setIdx(i=>(i+1)%filtered.length);setFlipped(false);}}>التالي ➡️</button>
        </div>
      </div>
    </div>
  );
}

// ======= REVIEW MODE (Spaced Repetition) =======
function ReviewMode({words,progress,updateProgress,dark}) {
  const [idx,setIdx]=useState(0);
  const [flipped,setFlipped]=useState(false);
  const [done,setDone]=useState(false);
  const [reviewed,setReviewed]=useState(0);

  if(words.length===0) return (
    <div style={{textAlign:"center",padding:"60px"}}>
      <div style={{fontSize:"64px",marginBottom:"16px"}}>🎉</div>
      <h2 style={{color:"#22c55e",marginBottom:"8px"}}>ممتاز!</h2>
      <p style={{color:"#64748b"}}>لا توجد كلمات تحتاج مراجعة الآن</p>
    </div>
  );

  if(done) return (
    <div style={{textAlign:"center",padding:"60px"}}>
      <div style={{fontSize:"64px",marginBottom:"16px"}}>✅</div>
      <h2 style={{color:"#22c55e",marginBottom:"8px"}}>أنهيت الجلسة!</h2>
      <p style={{color:"#64748b"}}>راجعت {reviewed} كلمة</p>
      <button className="btn btn-primary" style={{marginTop:"20px"}} onClick={()=>{setIdx(0);setDone(false);setReviewed(0);}}>جلسة جديدة</button>
    </div>
  );

  const word = words[idx];
  const p = progress[word?.id]||{mastery:0,interval:1};

  const rate = (r) => {
    updateProgress(word.id, r);
    setReviewed(v=>v+1);
    setFlipped(false);
    if(idx+1>=words.length) setDone(true);
    else setTimeout(()=>setIdx(i=>i+1),200);
  };

  return (
    <div>
      <h1 className="page-title">🔁 مراجعة ذكية (SM-2)</h1>
      <div style={{background:"#1e293b",borderRadius:"12px",padding:"12px 20px",marginBottom:"20px",display:"flex",gap:"20px"}}>
        <span style={{color:"#64748b"}}>الكلمة {idx+1} من {words.length}</span>
        <span style={{color:"#22c55e"}}>✅ تمت مراجعة {reviewed}</span>
        <span style={{color:"#60a5fa"}}>📅 التكرار القادم: {p.interval} يوم</span>
      </div>
      <div className="flashcard-container">
        <div className="flashcard" onClick={()=>setFlipped(!flipped)}>
          <div className={"card-inner "+(flipped?"flipped":"")}>
            <div className="card-front">
              {word.article && <div className="article-badge">{word.article}</div>}
              <div className="word-nl">{word.dutch}</div>
              <button className="audio-btn" onClick={e=>{e.stopPropagation();speak(word.dutch);}}>🔊</button>
              <div style={{color:"rgba(255,255,255,0.4)",fontSize:"12px",marginTop:"8px"}}>انقر للمعنى</div>
            </div>
            <div className="card-back">
              <div className="word-ar">{word.arabic}</div>
              {word.example_nl && <div className="example-box" style={{marginTop:"12px"}}><div className="example-nl">"{word.example_nl}"</div><div className="example-ar">{word.example_ar}</div></div>}
              <button className="audio-btn" onClick={e=>{e.stopPropagation();speak(word.dutch);}}>🔊</button>
            </div>
          </div>
        </div>
        {flipped && (
          <div className="rating-btns">
            <button className="rating-btn btn-again" onClick={()=>rate(1)}>😞 Again<br/><span style={{fontSize:"10px"}}>1 يوم</span></button>
            <button className="rating-btn btn-hard" onClick={()=>rate(2)}>😐 Hard<br/><span style={{fontSize:"10px"}}>{Math.max(1,p.interval-1)} يوم</span></button>
            <button className="rating-btn btn-good" onClick={()=>rate(4)}>🙂 Good<br/><span style={{fontSize:"10px"}}>{p.interval} يوم</span></button>
            <button className="rating-btn btn-easy" onClick={()=>rate(5)}>🎉 Easy<br/><span style={{fontSize:"10px"}}>{p.interval*2} يوم</span></button>
          </div>
        )}
      </div>
    </div>
  );
}

// ======= QUIZ MODE =======
function QuizMode({words,updateProgress,addXP,dark}) {
  const [qIdx,setQIdx]=useState(0);
  const [score,setScore]=useState(0);
  const [selected,setSelected]=useState(null);
  const [done,setDone]=useState(false);
  const [questions]=useState(()=>shuffle(words).slice(0,15).map(w=>{
    const wrong = shuffle(words.filter(x=>x.id!==w.id)).slice(0,3).map(x=>x.arabic);
    return {word:w, options:shuffle([w.arabic,...wrong])};
  }));

  if(done) return (
    <div style={{textAlign:"center",padding:"60px"}}>
      <div className="score-display">{score}/{questions.length}</div>
      <div style={{color:"#64748b",marginTop:"8px",fontSize:"18px"}}>نتيجتك</div>
      <div style={{color:"#f59e0b",fontSize:"24px",margin:"16px 0"}}>+{score*15} XP 🎉</div>
      <button className="btn btn-primary" onClick={()=>{setQIdx(0);setScore(0);setSelected(null);setDone(false);}}>من جديد</button>
    </div>
  );

  const q = questions[qIdx];
  const choose = (opt) => {
    if(selected) return;
    setSelected(opt);
    const correct = opt===q.word.arabic;
    if(correct) {setScore(s=>s+1);updateProgress(q.word.id,4);addXP(15);}
    else updateProgress(q.word.id,1);
    setTimeout(()=>{
      setSelected(null);
      if(qIdx+1>=questions.length) setDone(true);
      else setQIdx(i=>i+1);
    },1200);
  };

  return (
    <div>
      <h1 className="page-title">❓ اختبار متعدد الخيارات</h1>
      <div style={{display:"flex",justifyContent:"space-between",marginBottom:"20px"}}>
        <span style={{color:"#64748b"}}>السؤال {qIdx+1}/{questions.length}</span>
        <span style={{color:"#22c55e",fontWeight:700}}>✅ {score} صحيح</span>
      </div>
      <div className="progress-bar" style={{marginBottom:"24px"}}>
        <div className="progress-fill" style={{width:(qIdx/questions.length*100)+"%"}}></div>
      </div>
      <div className="flashcard-container">
        <div className="card" style={{width:"100%",textAlign:"center",background:"linear-gradient(135deg,#3b82f6,#8b5cf6)",border:"none"}}>
          {q.word.article && <div className="article-badge">{q.word.article}</div>}
          <div className="word-nl">{q.word.dutch}</div>
          <button className="audio-btn" onClick={()=>speak(q.word.dutch)}>🔊</button>
        </div>
        <div className="mc-options">
          {q.options.map((opt,i)=>(
            <button key={i} className={"mc-btn "+(selected?opt===q.word.arabic?"correct":opt===selected?"wrong":"":"")} onClick={()=>choose(opt)}>
              {opt}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}

// ======= MATCH GAME =======
function MatchGame({words,addXP,dark}) {
  const [gameWords]=useState(()=>shuffle(words).slice(0,8));
  const [cards,setCards]=useState(()=>{
    const c=[];
    shuffle(words).slice(0,8).forEach(w=>{
      c.push({id:"nl-"+w.id,content:w.dutch,wordId:w.id,type:"nl",matched:false,selected:false});
      c.push({id:"ar-"+w.id,content:w.arabic,wordId:w.id,type:"ar",matched:false,selected:false});
    });
    return shuffle(c);
  });
  const [selected,setSelected]=useState([]);
  const [matches,setMatches]=useState(0);
  const [errors,setErrors]=useState(0);
  const [time,setTime]=useState(0);
  const [done,setDone]=useState(false);
  const [shake,setShake]=useState([]);
  const timerRef=useRef();

  useEffect(()=>{
    timerRef.current=setInterval(()=>setTime(t=>t+1),1000);
    return ()=>clearInterval(timerRef.current);
  },[]);

  const click=(cardId)=>{
    const card=cards.find(c=>c.id===cardId);
    if(!card||card.matched||card.selected||selected.length>=2) return;
    const newSel=[...selected,cardId];
    setCards(prev=>prev.map(c=>c.id===cardId?{...c,selected:true}:c));
    setSelected(newSel);
    if(newSel.length===2){
      const [a,b]=newSel.map(id=>cards.find(c=>c.id===id));
      setTimeout(()=>{
        if(a.wordId===b.wordId&&a.type!==b.type){
          setCards(prev=>prev.map(c=>newSel.includes(c.id)?{...c,matched:true,selected:false}:c));
          const m=matches+1;
          setMatches(m);
          if(m===8){setDone(true);clearInterval(timerRef.current);addXP(Math.max(50,200-errors*10-time));}
        } else {
          setErrors(e=>e+1);
          setShake(newSel);
          setTimeout(()=>setShake([]),600);
          setCards(prev=>prev.map(c=>newSel.includes(c.id)?{...c,selected:false}:c));
        }
        setSelected([]);
      },500);
    }
  };

  if(done) return (
    <div style={{textAlign:"center",padding:"60px"}}>
      <div style={{fontSize:"64px",marginBottom:"16px"}}>🎉</div>
      <h2 style={{color:"#22c55e",marginBottom:"8px"}}>أحسنت!</h2>
      <p style={{color:"#64748b"}}>{Math.floor(time/60)}:{(time%60).toString().padStart(2,"0")} | {errors} أخطاء</p>
      <div style={{color:"#f59e0b",fontSize:"24px",margin:"16px 0"}}>+{Math.max(50,200-errors*10-time)} XP</div>
    </div>
  );

  return (
    <div>
      <h1 className="page-title">🎮 لعبة المطابقة</h1>
      <div style={{display:"flex",gap:"20px",marginBottom:"20px"}}>
        <span style={{color:"#60a5fa"}}>⏱ {Math.floor(time/60)}:{(time%60).toString().padStart(2,"0")}</span>
        <span style={{color:"#22c55e"}}>✅ {matches}/8</span>
        <span style={{color:"#ef4444"}}>❌ {errors}</span>
      </div>
      <div className="game-grid">
        {cards.map(c=>(
          <button key={c.id} className={"game-card "+(c.matched?"matched":c.selected?"selected":shake.includes(c.id)?"wrong":"")}
            onClick={()=>click(c.id)}
            style={{direction:c.type==="ar"?"rtl":"ltr",animation:shake.includes(c.id)?"shake 0.3s":""}}>
            {c.matched?"✓":c.content}
          </button>
        ))}
      </div>
    </div>
  );
}

// ======= FILL IN BLANK =======
function FillBlank({words,updateProgress,addXP,dark}) {
  const [idx,setIdx]=useState(0);
  const [input,setInput]=useState("");
  const [status,setStatus]=useState(null);
  const [score,setScore]=useState(0);
  const [qs]=useState(()=>shuffle(words).slice(0,10));

  if(idx>=qs.length) return (
    <div style={{textAlign:"center",padding:"60px"}}>
      <div className="score-display">{score}/{qs.length}</div>
      <div style={{color:"#f59e0b",fontSize:"20px",margin:"16px 0"}}>+{score*20} XP 🎉</div>
      <button className="btn btn-primary" onClick={()=>{setIdx(0);setInput("");setStatus(null);setScore(0);}}>من جديد</button>
    </div>
  );

  const q=qs[idx];
  const check=()=>{
    const ok=input.trim().toLowerCase()===q.dutch.toLowerCase();
    setStatus(ok?"correct":"wrong");
    if(ok){setScore(s=>s+1);updateProgress(q.id,4);addXP(20);}
    else updateProgress(q.id,1);
    setTimeout(()=>{setStatus(null);setInput("");setIdx(i=>i+1);},1500);
  };

  return (
    <div>
      <h1 className="page-title">✏️ أكمل الكلمة</h1>
      <div style={{marginBottom:"20px",color:"#64748b"}}>السؤال {idx+1}/{qs.length} — نقاط: {score}</div>
      <div className="flashcard-container">
        <div className="card" style={{width:"100%",textAlign:"center",background:"linear-gradient(135deg,#1e293b,#0f172a)",border:"1px solid #334155"}}>
          <p style={{color:"#94a3b8",fontSize:"14px",marginBottom:"8px"}}>اكتب الكلمة الهولندية:</p>
          <div className="word-ar">{q.arabic}</div>
          {q.example_ar && <div style={{color:"#64748b",fontSize:"13px",marginTop:"8px",direction:"rtl"}}>{q.example_ar}</div>}
        </div>
        <div style={{width:"100%"}}>
          <input
            className={"fill-input "+(status||"")}
            value={input}
            onChange={e=>setInput(e.target.value)}
            onKeyDown={e=>e.key==="Enter"&&input&&check()}
            placeholder="اكتب الكلمة الهولندية..."
            disabled={!!status}
            autoFocus
          />
        </div>
        {status==="wrong" && <div style={{color:"#ef4444",fontWeight:700}}>الإجابة الصحيحة: {q.dutch}</div>}
        <div style={{display:"flex",gap:"12px"}}>
          <button className="btn btn-primary" onClick={check} disabled={!input||!!status}>تحقق ✓</button>
          <button className="btn" style={{background:"#334155",color:"#94a3b8"}} onClick={()=>speak(q.dutch)}>🔊 استمع</button>
          <button className="btn" style={{background:"#334155",color:"#94a3b8"}} onClick={()=>{setStatus(null);setInput("");setIdx(i=>i+1);}}>تخطى ⏭</button>
        </div>
      </div>
    </div>
  );
}

// ======= SPEED CHALLENGE =======
function SpeedChallenge({words,addXP,dark}) {
  const [phase,setPhase]=useState("intro");
  const [qIdx,setQIdx]=useState(0);
  const [score,setScore]=useState(0);
  const [time,setTime]=useState(30);
  const [combo,setCombo]=useState(0);
  const [qs,setQs]=useState([]);
  const [flash,setFlash]=useState(null);

  useEffect(()=>{
    if(phase==="play"){
      const t=setInterval(()=>setTime(v=>{if(v<=1){setPhase("done");clearInterval(t);return 0;}return v-1;}),1000);
      return ()=>clearInterval(t);
    }
  },[phase]);

  const start=()=>{
    setQs(shuffle(words).map(w=>{
      const wrong=shuffle(words.filter(x=>x.id!==w.id)).slice(0,3).map(x=>x.arabic);
      return {word:w,options:shuffle([w.arabic,...wrong])};
    }));
    setQIdx(0);setScore(0);setTime(30);setCombo(0);setPhase("play");
  };

  if(phase==="intro") return (
    <div style={{textAlign:"center",padding:"60px"}}>
      <div style={{fontSize:"64px",marginBottom:"16px"}}>⚡</div>
      <h2 style={{marginBottom:"8px"}}>تحدي السرعة</h2>
      <p style={{color:"#64748b",marginBottom:"24px"}}>30 ثانية — أجب على أكبر عدد ممكن!</p>
      <button className="btn btn-primary" onClick={start}>ابدأ التحدي!</button>
    </div>
  );

  if(phase==="done") return (
    <div style={{textAlign:"center",padding:"60px"}}>
      <div className="score-display">{score}</div>
      <div style={{color:"#64748b",marginTop:"8px"}}>إجابة صحيحة!</div>
      <div style={{color:"#f59e0b",fontSize:"20px",margin:"16px 0"}}>+{score*25} XP 🏆</div>
      <button className="btn btn-primary" onClick={start}>العب مجدداً</button>
    </div>
  );

  if(!qs[qIdx]) return null;
  const q=qs[qIdx];

  const choose=(opt)=>{
    const ok=opt===q.word.arabic;
    setFlash(ok?"correct":"wrong");
    if(ok){setScore(s=>s+1+(combo>=3?1:0));setCombo(c=>c+1);addXP(10);}
    else setCombo(0);
    setTimeout(()=>{setFlash(null);setQIdx(i=>i+1);},300);
  };

  return (
    <div style={{maxWidth:"600px",margin:"0 auto"}}>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:"20px"}}>
        <span className="timer" style={{fontSize:"36px",color:time<=10?"#ef4444":"#f59e0b"}}>{time}s</span>
        <div style={{textAlign:"center"}}>
          <div style={{color:"#22c55e",fontWeight:800,fontSize:"24px"}}>{score}</div>
          <div style={{color:"#64748b",fontSize:"12px"}}>نقاط</div>
        </div>
        {combo>=3 && <div style={{color:"#f59e0b",fontWeight:800}}>🔥 Combo x{combo}!</div>}
      </div>
      <div className="progress-bar" style={{marginBottom:"16px",height:"6px"}}>
        <div className="progress-fill" style={{width:(time/30*100)+"%",background:"linear-gradient(90deg,#22c55e,#3b82f6)"}}></div>
      </div>
      <div style={{background:flash==="correct"?"rgba(34,197,94,0.3)":flash==="wrong"?"rgba(239,68,68,0.3)":"linear-gradient(135deg,#3b82f6,#8b5cf6)",borderRadius:"20px",padding:"32px",textAlign:"center",marginBottom:"16px",transition:"background 0.2s"}}>
        <div className="word-nl">{q.word.dutch}</div>
        <button className="audio-btn" onClick={()=>speak(q.word.dutch)}>🔊</button>
      </div>
      <div className="mc-options">
        {q.options.map((opt,i)=>(
          <button key={i} className="mc-btn" onClick={()=>choose(opt)}>{opt}</button>
        ))}
      </div>
    </div>
  );
}

// ======= WORD LIST =======
function WordList({words,progress,setPage,dark}) {
  const [search,setSearch]=useState("");
  const [filter,setFilter]=useState("all");
  const filtered=words.filter(w=>{
    const q=search.toLowerCase();
    const match=!q||w.dutch.toLowerCase().includes(q)||w.arabic.includes(q)||(w.synonyms||[]).some(s=>s.toLowerCase().includes(q));
    if(!match) return false;
    if(filter==="new") return !progress[w.id];
    if(filter==="mastered") return (progress[w.id]?.mastery||0)>=4;
    if(filter==="nt2") return w.isNT2Key;
    return true;
  });

  return (
    <div>
      <h1 className="page-title">📝 قائمة الكلمات ({filtered.length})</h1>
      <input className="search-box" placeholder="ابحث بالهولندية أو العربية أو المرادفات..." value={search} onChange={e=>setSearch(e.target.value)} style={{background:dark?"#1e293b":"#fff",color:dark?"#f1f5f9":"#1e293b"}}/>
      <div style={{display:"flex",gap:"8px",marginBottom:"20px",flexWrap:"wrap"}}>
        {[["all","الكل"],["new","جديدة"],["mastered","محفوظة"],["nt2","NT2 أساسية"]].map(([v,l])=>(
          <button key={v} className={"thema-btn "+(filter===v?"active":"")} onClick={()=>setFilter(v)}>{l}</button>
        ))}
      </div>
      <div className="word-list">
        {filtered.map(w=>{
          const m=progress[w.id]?.mastery||0;
          return (
            <div key={w.id} className="word-item" style={{background:dark?"#1e293b":"#fff",border:"1px solid "+(dark?"#334155":"#e2e8f0")}}>
              <div className="mastery-dot" style={{background:getMasteryColor(m)}}></div>
              <div style={{flex:1}}>
                <div style={{display:"flex",alignItems:"center",gap:"8px"}}>
                  <span className="word-item-nl">{w.article&&<span style={{color:"#64748b",fontSize:"13px"}}>{w.article} </span>}{w.dutch}</span>
                  {w.isNT2Key && <span style={{background:"#f59e0b22",color:"#f59e0b",padding:"2px 8px",borderRadius:"10px",fontSize:"11px"}}>NT2</span>}
                  <span className={"badge "+(w.type==="noun"?"badge-noun":w.type==="verb"?"badge-verb":"badge-adj")}>
                    {w.type==="noun"?"اسم":w.type==="verb"?"فعل":w.type==="adjective"?"صفة":"كلمة"}
                  </span>
                </div>
                <div className="word-item-ar">{w.arabic}</div>
                {w.synonyms&&w.synonyms.length>0&&<div style={{color:"#475569",fontSize:"12px",marginTop:"2px"}}>= {w.synonyms.slice(0,2).join(" / ")}</div>}
              </div>
              <button onClick={()=>speak(w.dutch)} style={{background:"none",border:"none",color:"#60a5fa",fontSize:"20px",cursor:"pointer"}}>🔊</button>
            </div>
          );
        })}
      </div>
    </div>
  );
}

// ======= AI TUTOR =======
function AITutor({words,dark}) {
  const [msgs,setMsgs]=useState([{role:"ai",text:"مرحباً! أنا مدرسك الهولندي الذكي 🤖\nيمكنني مساعدتك في:\n• شرح الكلمات بالعربية\n• إنشاء أمثلة جديدة\n• الفرق بين الكلمات المتشابهة\n• إجراء محادثة هولندية\n\nاسألني عن أي كلمة!"}]);
  const [input,setInput]=useState("");
  const [loading,setLoading]=useState(false);
  const chatRef=useRef();

  useEffect(()=>{
    if(chatRef.current) chatRef.current.scrollTop=chatRef.current.scrollHeight;
  },[msgs]);

  const getAIResponse=(question)=>{
    const q=question.toLowerCase();
    const word=words.find(w=>q.includes(w.dutch.toLowerCase())||q.includes(w.arabic));
    
    if(q.includes("فرق")||q.includes("verschil")){
      const w1=words.find(w=>q.includes(w.dutch.toLowerCase()));
      if(w1){
        const similar=words.filter(w=>w.thema===w1.thema&&w.type===w1.type&&w.id!==w1.id).slice(0,2);
        return `الفرق بين "${w1.dutch}" والكلمات المشابهة:\n\n🔵 ${w1.dutch} = ${w1.arabic}\n${w1.example_nl}\n\n`+(similar.map(s=>`🔹 ${s.dutch} = ${s.arabic}\n${s.example_nl||""}`).join("\n\n"))+
          "\n\nالفرق الرئيسي: كل كلمة تستخدم في سياق مختلف.";
      }
    }
    
    if(word){
      const responses=[
        `📖 **${word.dutch}** ${word.article?"("+word.article+")":""}\n\n🇦🇪 المعنى: ${word.arabic}\n\n📝 نوع: ${word.type==="noun"?"اسم":word.type==="verb"?"فعل":"صفة"}\n\n💬 مثال:\n"${word.example_nl}"\n${word.example_ar}\n\n${word.synonyms&&word.synonyms.length>0?"🔄 مرادفات: "+word.synonyms.join(", "):""}`,
        `هل تريد مثالاً آخر على استخدام "${word.dutch}"?\n\nفي هولندا يستخدمون هذه الكلمة كثيراً في سياق: ${word.themaName}.\n\nتمرين: حاول أن تكتب جملة تحتوي على "${word.dutch}" ✍️`,
      ];
      return responses[Math.floor(Math.random()*responses.length)];
    }
    
    if(q.includes("مثال")||q.includes("voorbeeld")){
      const rw=words[Math.floor(Math.random()*words.length)];
      return `مثال جديد:\n\n"${rw.example_nl}"\n${rw.example_ar}\n\nالكلمة الرئيسية: **${rw.dutch}** = ${rw.arabic}`;
    }
    
    if(q.includes("صعب")||q.includes("moeilijk")){
      const hard=words.filter(w=>w.difficulty>=4);
      return `الكلمات الصعبة (مستوى 4-5):\n\n`+hard.slice(0,5).map(w=>`• ${w.dutch} = ${w.arabic}`).join("\n")+
        "\n\nنصيحة: راجع هذه الكلمات يومياً باستخدام نظام SM-2 🧠";
    }
    
    if(q.includes("nt2")||q.includes("امتحان")){
      const nt2=words.filter(w=>w.isNT2Key);
      return `🎓 أهم كلمات امتحان NT2:\n\n`+nt2.slice(0,8).map(w=>`✅ ${w.dutch} = ${w.arabic}`).join("\n")+
        `\n\n📊 إجمالي كلمات NT2 الأساسية: ${nt2.length} كلمة\nنصيحة: ركز على هذه الكلمات أولاً!`;
    }
    
    if(q.includes("محادثة")||q.includes("gesprek")){
      const rws=shuffle(words).slice(0,3);
      return `🗣️ لنتحدث هولندي!\n\nقل: "Goedemiddag! Hoe gaat het met u?"\n(مرحباً بالنهار! كيف حالك؟)\n\nكلمات اليوم:\n`+rws.map(w=>`• ${w.dutch} — ${w.arabic}`).join("\n")+
        "\n\nحاول استخدام هذه الكلمات في جملة!";
    }
    
    const rw=words[Math.floor(Math.random()*words.length)];
    return `سؤال رائع! 🌟\n\nهل تعرف كلمة اليوم؟\n\n**${rw.dutch}** = ${rw.arabic}\n\n"${rw.example_nl}"\n${rw.example_ar}\n\nاسألني عن أي كلمة أو موضوع!`;
  };

  const send=()=>{
    if(!input.trim()) return;
    const q=input;
    setMsgs(m=>[...m,{role:"user",text:q}]);
    setInput("");
    setLoading(true);
    setTimeout(()=>{
      setMsgs(m=>[...m,{role:"ai",text:getAIResponse(q)}]);
      setLoading(false);
    },800);
  };

  const suggestions=["اشرح كلمة inburgering","ما الفرق بين huren و kopen؟","ما هي كلمات NT2 الأهم؟","أعطني مثالاً جديداً","الكلمات الصعبة","لنتحدث هولندي"];

  return (
    <div>
      <h1 className="page-title">🤖 مدرس ذكي</h1>
      <div ref={chatRef} className="ai-chat">
        {msgs.map((m,i)=>(
          <div key={i} className={"msg "+(m.role==="ai"?"msg-ai":"msg-user")} style={{whiteSpace:"pre-line",direction:m.role==="ai"?"auto":"rtl"}}>
            {m.role==="ai" && <span style={{display:"block",fontSize:"18px",marginBottom:"4px"}}>🤖</span>}
            {m.text}
          </div>
        ))}
        {loading && <div className="msg msg-ai">🤔 أفكر...</div>}
      </div>
      <div style={{display:"flex",flexWrap:"wrap",gap:"6px",margin:"12px 0"}}>
        {suggestions.map((s,i)=>(
          <button key={i} onClick={()=>{setInput(s);}} style={{background:"#1e293b",border:"1px solid #334155",color:"#94a3b8",padding:"6px 12px",borderRadius:"20px",cursor:"pointer",fontSize:"12px"}}>{s}</button>
        ))}
      </div>
      <div className="chat-input">
        <input value={input} onChange={e=>setInput(e.target.value)} onKeyDown={e=>e.key==="Enter"&&send()} placeholder="اسأل عن أي كلمة..." style={{background:dark?"#1e293b":"#f8fafc",color:dark?"#f1f5f9":"#1e293b"}}/>
        <button className="btn btn-primary" onClick={send}>إرسال ➤</button>
      </div>
    </div>
  );
}

// ======= STATISTICS =======
function Statistics({stats,progress,words,accuracy,dark}) {
  const masteryDist=[0,0,0,0,0,0];
  Object.values(progress).forEach(p=>masteryDist[p.mastery||0]++);
  const masteryLabels=["جديدة","أتعلمها","مراجعة","مألوفة","محفوظة","خبير"];
  const masteryColors=["#6b7280","#ef4444","#f97316","#eab308","#22c55e","#3b82f6"];
  const themaStats={};
  words.forEach(w=>{
    if(!themaStats[w.themaName]) themaStats[w.themaName]={total:0,done:0};
    themaStats[w.themaName].total++;
    if(progress[w.id]) themaStats[w.themaName].done++;
  });

  return (
    <div>
      <h1 className="page-title">📊 إحصائياتي</h1>
      
      {/* Main Stats */}
      <div className="stats-grid" style={{marginBottom:"24px"}}>
        {[
          {val:stats.xp,label:"XP الكلية",color:"#f59e0b",icon:"⭐"},
          {val:"Level "+stats.level,label:"مستواي",color:"#3b82f6",icon:"🏆"},
          {val:stats.streak+"🔥",label:"أيام متتالية",color:"#ef4444",icon:""},
          {val:stats.totalReviews,label:"إجمالي المراجعات",color:"#22c55e",icon:"🔄"},
          {val:accuracy+"%",label:"دقة الإجابات",color:"#8b5cf6",icon:"🎯"},
          {val:stats.correct,label:"إجابات صحيحة",color:"#22c55e",icon:"✅"},
        ].map((s,i)=>(
          <div key={i} className="stat-card" style={{borderLeft:"4px solid "+s.color}}>
            <div className="stat-val" style={{color:s.color}}>{s.icon} {s.val}</div>
            <div className="stat-label">{s.label}</div>
          </div>
        ))}
      </div>

      {/* Mastery Distribution */}
      <div className="card" style={{background:dark?"#1e293b":"#fff",marginBottom:"20px"}}>
        <h3 style={{marginBottom:"16px",color:"#60a5fa"}}>📈 توزيع مستوى الإتقان</h3>
        {masteryLabels.map((label,i)=>(
          <div key={i} style={{display:"flex",alignItems:"center",gap:"12px",marginBottom:"10px"}}>
            <span style={{width:"70px",fontSize:"13px",color:"#94a3b8",textAlign:"right"}}>{label}</span>
            <div style={{flex:1,background:"#334155",borderRadius:"4px",overflow:"hidden",height:"20px"}}>
              <div style={{width:Math.max(4,(masteryDist[i]/words.length*100))+"%",height:"100%",background:masteryColors[i],borderRadius:"4px",transition:"width 0.5s"}}></div>
            </div>
            <span style={{width:"30px",color:masteryColors[i],fontWeight:700,fontSize:"13px"}}>{masteryDist[i]}</span>
          </div>
        ))}
      </div>

      {/* Thema Progress */}
      <div className="card" style={{background:dark?"#1e293b":"#fff"}}>
        <h3 style={{marginBottom:"16px",color:"#60a5fa"}}>📚 التقدم حسب الموضوع</h3>
        {Object.entries(themaStats).map(([name,{total,done}],i)=>(
          <div key={i} style={{marginBottom:"12px"}}>
            <div style={{display:"flex",justifyContent:"space-between",marginBottom:"4px"}}>
              <span style={{fontSize:"13px",color:"#94a3b8"}}>{name}</span>
              <span style={{fontSize:"13px",color:"#60a5fa"}}>{done}/{total}</span>
            </div>
            <div className="progress-bar">
              <div className="progress-fill" style={{width:(done/total*100)+"%"}}></div>
            </div>
          </div>
        ))}
      </div>

      {/* Achievements */}
      <div className="card" style={{background:dark?"#1e293b":"#fff",marginTop:"20px"}}>
        <h3 style={{marginBottom:"16px",color:"#60a5fa"}}>🏅 الإنجازات</h3>
        <div style={{display:"grid",gap:"10px"}}>
          {[
            {icon:"🎯",name:"أول كلمة",desc:"راجعت أول كلمة",done:stats.totalReviews>=1},
            {icon:"📚",name:"مبتدئ",desc:"راجعت 10 كلمات",done:stats.totalReviews>=10},
            {icon:"⭐",name:"متقدم",desc:"راجعت 50 كلمة",done:stats.totalReviews>=50},
            {icon:"🔥",name:"On Fire",desc:"سلسلة 7 أيام",done:stats.streak>=7},
            {icon:"🏆",name:"خبير",desc:"راجعت 100 كلمة",done:stats.totalReviews>=100},
            {icon:"💎",name:"NT2 Ready",desc:"أتقنت 50 كلمة",done:Object.values(progress).filter(p=>p.mastery>=4).length>=50},
          ].map((a,i)=>(
            <div key={i} className="achievement" style={{opacity:a.done?1:0.4,background:dark?"#0f172a":"#f8fafc"}}>
              <span className="ach-icon">{a.icon}</span>
              <div>
                <div className="ach-name">{a.name} {a.done?"✅":""}</div>
                <div className="ach-desc">{a.desc}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

// ======= EXAM MODE =======
function ExamMode({words,progress,updateProgress,addXP,dark}) {
  const [phase,setPhase]=useState("intro");
  const [qIdx,setQIdx]=useState(0);
  const [answers,setAnswers]=useState([]);
  const [selected,setSelected]=useState(null);
  const [qs,setQs]=useState([]);

  const start=(mode)=>{
    let pool=words;
    if(mode==="weak") pool=words.filter(w=>!progress[w.id]||(progress[w.id].mastery||0)<=2);
    if(mode==="nt2") pool=words.filter(w=>w.isNT2Key);
    const q=shuffle(pool).slice(0,20).map(w=>{
      const type=Math.random()>0.5?"nl-ar":"ar-nl";
      const wrong=shuffle(words.filter(x=>x.id!==w.id)).slice(0,3).map(x=>type==="nl-ar"?x.arabic:x.dutch);
      return {word:w,type,options:shuffle([type==="nl-ar"?w.arabic:w.dutch,...wrong])};
    });
    setQs(q);setQIdx(0);setAnswers([]);setSelected(null);setPhase("exam");
  };

  if(phase==="intro") return (
    <div style={{maxWidth:"500px",margin:"0 auto",textAlign:"center",padding:"40px"}}>
      <div style={{fontSize:"64px",marginBottom:"16px"}}>🎓</div>
      <h2 style={{marginBottom:"8px"}}>وضع الامتحان</h2>
      <p style={{color:"#64748b",marginBottom:"32px"}}>محاكاة امتحان NT2 الحقيقي</p>
      <div style={{display:"grid",gap:"12px"}}>
        <button className="btn btn-primary" style={{padding:"20px",fontSize:"16px"}} onClick={()=>start("all")}>📝 امتحان شامل (20 سؤال)</button>
        <button className="btn btn-primary" style={{padding:"20px",fontSize:"16px",background:"#ef4444"}} onClick={()=>start("weak")}>🔴 الكلمات الضعيفة</button>
        <button className="btn btn-primary" style={{padding:"20px",fontSize:"16px",background:"#f59e0b"}} onClick={()=>start("nt2")}>⭐ كلمات NT2 الأساسية</button>
      </div>
    </div>
  );

  if(phase==="result"){
    const correct=answers.filter(a=>a).length;
    const pct=Math.round(correct/qs.length*100);
    return (
      <div style={{textAlign:"center",padding:"40px"}}>
        <div className="score-display" style={{color:pct>=80?"#22c55e":pct>=60?"#f59e0b":"#ef4444"}}>{pct}%</div>
        <div style={{fontSize:"18px",color:"#64748b",margin:"8px 0"}}>{correct}/{qs.length} صحيح</div>
        <div style={{color:pct>=80?"#22c55e":pct>=60?"#f59e0b":"#ef4444",fontSize:"20px",marginBottom:"24px"}}>
          {pct>=80?"ممتاز! أنت جاهز للامتحان 🏆":pct>=60?"جيد! استمر في التدريب 💪":"تحتاج مزيداً من المراجعة 📚"}
        </div>
        <div style={{color:"#f59e0b",fontSize:"20px",marginBottom:"20px"}}>+{correct*20} XP</div>
        <button className="btn btn-primary" onClick={()=>setPhase("intro")}>امتحان جديد</button>
      </div>
    );
  }

  if(!qs[qIdx]) return null;
  const q=qs[qIdx];
  const choose=(opt)=>{
    if(selected) return;
    const correct=opt===(q.type==="nl-ar"?q.word.arabic:q.word.dutch);
    setSelected(opt);
    const newAnswers=[...answers,correct];
    if(correct){updateProgress(q.word.id,4);addXP(20);}
    else updateProgress(q.word.id,1);
    setTimeout(()=>{
      setSelected(null);
      if(qIdx+1>=qs.length){setAnswers(newAnswers);setPhase("result");}
      else{setAnswers(newAnswers);setQIdx(i=>i+1);}
    },1200);
  };

  return (
    <div style={{maxWidth:"600px",margin:"0 auto"}}>
      <div style={{display:"flex",justifyContent:"space-between",marginBottom:"16px"}}>
        <h1 className="page-title" style={{marginBottom:0}}>🎓 الامتحان</h1>
        <span style={{color:"#64748b"}}>السؤال {qIdx+1}/{qs.length}</span>
      </div>
      <div className="progress-bar" style={{marginBottom:"20px"}}>
        <div className="progress-fill" style={{width:(qIdx/qs.length*100)+"%"}}></div>
      </div>
      <div style={{background:"linear-gradient(135deg,#1e293b,#0f172a)",border:"1px solid #334155",borderRadius:"20px",padding:"32px",textAlign:"center",marginBottom:"20px"}}>
        <div style={{color:"#64748b",fontSize:"13px",marginBottom:"8px"}}>
          {q.type==="nl-ar"?"ما معنى هذه الكلمة بالعربية؟":"ما هي الكلمة الهولندية؟"}
        </div>
        {q.type==="nl-ar"&&q.word.article&&<div className="article-badge">{q.word.article}</div>}
        <div className={q.type==="nl-ar"?"word-nl":"word-ar"} style={{fontSize:"36px"}}>
          {q.type==="nl-ar"?q.word.dutch:q.word.arabic}
        </div>
        {q.type==="nl-ar"&&<button className="audio-btn" onClick={()=>speak(q.word.dutch)}>🔊</button>}
      </div>
      <div className="mc-options">
        {q.options.map((opt,i)=>(
          <button key={i} className={"mc-btn "+(selected?(opt===(q.type==="nl-ar"?q.word.arabic:q.word.dutch)?"correct":opt===selected?"wrong":""):"")}
            onClick={()=>choose(opt)}
            style={{direction:q.type==="nl-ar"?"rtl":"ltr"}}>
            {opt}
          </button>
        ))}
      </div>
    </div>
  );
}
